import { Component, input, OnInit, AfterViewInit, OnDestroy, inject, DOCUMENT, ElementRef, viewChild } from '@angular/core';
import { FlowItemModel } from '../../../shared/models/FlowItemModel';
import { RankingLanguage } from '../../../shared/models/ReportModels';
declare var google:any;

@Component({
  selector: 'app-chart-player-projection',
  imports: [],
  templateUrl: './chart-player-projection.component.html',
  styleUrl: './chart-player-projection.component.css',
})
export class ChartPlayerProjectionComponent implements OnInit, AfterViewInit, OnDestroy {
  PlayerId =input<string>();
  Reports =input<FlowItemModel[]>();
  ProjectionScale =input<RankingLanguage[]>();

  private document = inject(DOCUMENT);
  private chartContainer = viewChild.required<ElementRef<HTMLDivElement>>('chartContainer');
  private resizeObserver?: ResizeObserver;
  private lastDrawnWidth = 0;

  private getThemeColor(variableName: string, fallback: string) {
    const value = getComputedStyle(this.document.documentElement)
      .getPropertyValue(variableName)
      .trim();

    return value || fallback;
  }

  private getChartTheme() {
    // Check the overlay container or body for theme class
    const overlayContainer = this.document.querySelector('.cdk-overlay-container');
    const isDarkTheme = overlayContainer?.classList.contains('darkMode') || 
                        this.document.body.classList.contains('darkMode') ||
                        localStorage.getItem('theme') === 'dark';
    
    if (isDarkTheme) {
      return {
        backgroundColor: this.getThemeColor('--mat-sys-background', '#303030'),
        textColor: this.getThemeColor('--mat-sys-on-background', 'white'),
        baselineColor: this.getThemeColor('--mat-sys-on-background', 'white'),
        lineColor: '#90CAF9',
        currentLevelColor: '#9E9E9E',
        gridlineColor: '#616161'
      };
    } else {
      return {
        backgroundColor: this.getThemeColor('--mat-sys-background', '#f3f5f8'),
        textColor: this.getThemeColor('--mat-sys-on-background', '#212121'),
        baselineColor: this.getThemeColor('--mat-sys-on-background', '#212121'),
        lineColor: '#1976D2',
        currentLevelColor: '#000000',
        gridlineColor: '#e0e0e0'
      };

    }
  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {

      var container = this.chartContainer().nativeElement;
      // console.log(this.document.body.classList);
      google.charts.load('current', {'packages':['corechart']});
      google.charts.setOnLoadCallback(() => {
        // Redraw whenever the container width changes (rotation, resize, or the tab becoming visible).
        // Drawing while hidden (width 0) makes Google Charts fall back to a fixed 400px width.
        const redraw = () => {
          const width = container.clientWidth;
          if (width === 0 || width === this.lastDrawnWidth) return;
          this.lastDrawnWidth = width;
          drawChart(width);
        };
        this.resizeObserver = new ResizeObserver(() => redraw());
        this.resizeObserver.observe(container);
        redraw();
      });
      var reports = this.Reports() ?? [];
      var projectionScale = this.ProjectionScale() ?? [];
      var theme = this.getChartTheme();
    

      function drawChart(width: number) {
        // Create the data table.
        var data = new google.visualization.DataTable();
        var dataforcomparison = new google.visualization.DataTable();
        var dataOKLimit = new google.visualization.DataTable();

        data.addColumn('date', 'Date');
        data.addColumn('number', 'Projection');
        data.addColumn('number', 'CurrentLevel');
        
        var minDate = new Date(new Date().getFullYear() - 5, 6, 1); //1st of July, 5 years ago
        
        var _data: (number | Date | null)[][] = [];
        reports.forEach(report => {
            var dateCreated = new Date(report.DateCreated);
            var year = dateCreated.getFullYear();
            var month = dateCreated.getMonth();
            var day = dateCreated.getDate();
            var reportDate = new Date(year, month, day);

            if(reportDate<minDate)
              minDate = new Date(reportDate.getFullYear()-1, reportDate.getMonth(), reportDate.getDate());

            const currentLevelValue = report.CurrentLevelRanking === 0 ? null : report.CurrentLevelRanking;
            const totalQualityValue = report.TotalQuality === 0 ? null : report.TotalQuality;
            _data.push([reportDate, totalQualityValue, currentLevelValue]);
          
                 
        });
        data.addRows(_data);

        // Create custom y-axis ticks from projection scale
        var yAxisTicks = projectionScale.map((scale: RankingLanguage, index: number) => ({
          v: scale.Ranking,
          f: scale.Text
        }));

        
        /* if(firstREportDate<minDate)
          minDate = new Date(firstREportDate.getFullYear()-1, firstREportDate.getMonth(), firstREportDate.getDate()); //add one month before first report date */
        var maxDate = new Date();
        var options = {
        
          width: width,
          height: container.clientHeight,
          // Fixed pixel insets so the plot always fits and leaves room for the x-axis date labels
          chartArea: {
            left: 60,
            right: 12,
            top: 15,
            bottom: 35
          },
          legend: { position: 'none' },
          histogram: { bucketSize: 1 },
          colors: [theme.lineColor, theme.currentLevelColor],
          pointSize: 5,
          backgroundColor: theme.backgroundColor,
          hAxis: { 
            textStyle: { color: theme.textColor }, 
            baselineColor: theme.baselineColor, 
            gridlines: { color: theme.gridlineColor },
            minorGridlines: { count: 0 },
            minValue: minDate,
            maxValue: maxDate,
            slantedText: false,
            maxAlternation: 1
          },
          vAxis: { 
            textStyle: { color: theme.textColor }, 
            baselineColor: theme.baselineColor,
            gridlines: { color: theme.gridlineColor },
            ticks: yAxisTicks.length > 0 ? yAxisTicks : undefined
          },
        }

        var chart = new google.visualization.LineChart(container);
        chart.draw(data, options);


      }


  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }


}
